import { createFileRoute } from '@tanstack/react-router'
import TestSubmissionsPage from '@/pages/(protected)/workspaces/[workspaceId]/compliance/tests/[testId]/submissions'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/tests_/$testId/submissions'
)({
  component: TestSubmissionsPage,
})
